import { create } from "zustand";
import l10n from "../lib/l10n";

const getTheProduct = () => l10n.__getvar('p_');

export const useProduct = create((set, get) => ({
  product: getTheProduct(),
  setProduct: product => set({ product }),
  showInfo: false,
  setShowInfo: () => set({ showInfo: !get().showInfo }),
}));